import { useQuery } from "@tanstack/react-query";
import { facilityApi } from "@bw/shared/api";
import type { BookingResponse } from "@bw/shared/types/generated";
import { queryKeys } from "../../../common/query/queryClient";

/**
 * Reservations the player hosts or currently participates in at one facility
 * (GET /facilities/{id}/bookings).
 *
 * The backend scopes the list to the token user server-side — there is no
 * client-side identity filter to forge. Accepted-participant rows keep the host
 * identity but redact host-owned money. This is the facility-scoped companion to
 * `useAllBookings`; the page renders the server's deterministic order.
 */
export function useMyBookings(facilityId: string | undefined) {
  return useQuery<BookingResponse[]>({
    queryKey: queryKeys.booking.myBookings(facilityId ?? ""),
    queryFn: () => facilityApi.listBookings(facilityId as string),
    enabled: Boolean(facilityId),
  });
}
